import { DATATYPE_BASIC, DATATYPE_BACKTOCHINA, DATATYPE_CONTACT, DATATYPE_ADDRESS, DATATYPE_DOCUMENT, DATATYPE_SCHOOL, DATATYPE_DOSE } from '../databases/spName'

export const ICON_HEADER_SIGNOUT = <i className='fa fa-sign-out fa-lg' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_USER = <i className='fa fa-user fa-lg' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_BARS = <i className='fa fa-bars fa-lg' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_DATABASE = <i className='fa fa-database fa-lg' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_GEAR = <i className='fa fa-gear fa-lg' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_LOCK = <i className='fa fa-lock fa-lg' style={{pointerEvents: 'none'}} />

export const ICON_HEADER_TABLE = <i className='fa fa-cloud-download fa-lg' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_FLIGHT = <i className='fa fa-plane fa-lg' style={{pointerEvents: 'none'}} />

export const ICON_HEADER_HOME = <i className='fa fa-sign-in fa-lg' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_REGISTER = <i className='fa fa-user-plus fa-lg' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_FAQ = <i className='fa fa-question fa-lg' style={{pointerEvents: 'none'}} />

export const ICON_HEADER_SM_SIGNOUT = <i className='fa fa-sign-out fa-sm' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_SM_USER = <i className='fa fa-user fa-sm' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_SM_BARS = <i className='fa fa-bars fa-sm' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_SM_DATABASE = <i className='fa fa-database fa-sm' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_SM_GEAR = <i className='fa fa-gear fa-sm' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_SM_LOCK = <i className='fa fa-lock fa-sm' style={{pointerEvents: 'none'}} />

export const ICON_HEADER_SM_TABLE = <i className='fa fa-cloud-download fa-sm' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_SM_FLIGHT = <i className='fa fa-plane fa-sm' style={{pointerEvents: 'none'}} />

export const ICON_HEADER_SM_HOME = <i className='fa fa-sign-in fa-sm' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_SM_REGISTER = <i className='fa fa-user-plus fa-sm' style={{pointerEvents: 'none'}} />
export const ICON_HEADER_SM_FAQ = <i className='fa fa-question fa-sm' style={{pointerEvents: 'none'}} />

export const ICON_LOGIN_SIGNIN = <i className='fa fa-sign-in' style={{pointerEvents: 'none', width : '24px'}} />
export const ICON_LOGIN_REGISTER = <i className='fa fa-user-plus' style={{pointerEvents: 'none', width : '24px'}} />
export const ICON_LOGIN_FORGOT = <i className='fa fa-unlock' style={{pointerEvents: 'none', width : '24px'}} />

export const ICON_UPLOAD = <i className='fa fa-upload' style={{pointerEvents: 'none'}} />
export const ICON_DOWNLOAD = <i className='fa fa-download' style={{pointerEvents: 'none'}} />
export const ICON_REMOVE = <i className='fa fa-trash' style={{pointerEvents: 'none'}} />

export const ICON_EDIT = <i className='fa fa-gear' style={{pointerEvents: 'none'}} />

export const ICON_ANSWER = <i className='fa fa-arrow-right' style={{pointerEvents: 'none', width : '30px'}} />

const ICON_PROFILE_BASIC = <i className='fa fa-user' style={{pointerEvents: 'none', width : '25px'}} />
const ICON_PROFILE_BACKTOCHINA = <i className='fa fa-plane' style={{pointerEvents: 'none', width : '25px'}} />
const ICON_PROFILE_SCHOOL = <i className='fa fa-graduation-cap' style={{pointerEvents: 'none', width : '25px'}} />
const ICON_PROFILE_CONTACT = <i className='fa fa-address-card' style={{pointerEvents: 'none', width : '25px'}} />
const ICON_PROFILE_ADDRESS = <i className='fa fa-map-marker' style={{pointerEvents: 'none', width : '25px'}} />
const ICON_PROFILE_DOCUMENT = <i className='fa fa-file-text' style={{pointerEvents: 'none', width : '25px'}} />
const ICON_PROFILE_DOSE = <i className='fa fa-medkit' style={{pointerEvents: 'none', width : '25px'}} />
export const ICON_PROFILE = {
    [DATATYPE_BASIC] : ICON_PROFILE_BASIC,
    [DATATYPE_SCHOOL] : ICON_PROFILE_SCHOOL,
    [DATATYPE_BACKTOCHINA] : ICON_PROFILE_BACKTOCHINA,
    [DATATYPE_CONTACT] : ICON_PROFILE_CONTACT,
    [DATATYPE_ADDRESS] : ICON_PROFILE_ADDRESS,
    [DATATYPE_DOCUMENT] : ICON_PROFILE_DOCUMENT,
    [DATATYPE_DOSE] : ICON_PROFILE_DOSE
}
export const ICON_PROFILE_EDIT = <i className='fa fa-pencil-square' style={{pointerEvents: 'none', width : '25px'}} />
export const ICON_PROFILE_OK = <i className='fa fa-check-square' style={{pointerEvents: 'none', width : '25px'}} />
export const ICON_PROFILE_CANCEL = <i className='fa fa-window-close' style={{pointerEvents: 'none', width : '25px'}} />



const ICON_STEP_CHECKLIST = <i className='fa fa-list-ol' style={{pointerEvents: 'none'}} />
const ICON_STEP_TICKET = <i className='fa fa-ticket' style={{pointerEvents: 'none'}} />
const ICON_STEP_VISA = <i className='fa fa-book' style={{pointerEvents: 'none'}} />
const ICON_STEP_HOSPITAL = <i className='fa fa-hospital-o' style={{pointerEvents: 'none'}} />
const ICON_STEP_JKM = <i className='fa fa-qrcode' style={{pointerEvents: 'none'}} />
const ICON_STEP_BAG = <i className='fa fa-suitcase' style={{pointerEvents: 'none'}} />
export const ICON_STEP = {
    0 : ICON_STEP_CHECKLIST,
    1 : ICON_STEP_TICKET,
    2 : ICON_STEP_VISA,
    3 : ICON_STEP_HOSPITAL,
    4 : ICON_STEP_JKM,
    5 : ICON_STEP_BAG,
}